import * as React from 'react'

import { Text } from '../text/Text'

export type SliderValueType = {
  outputLabel?: (value: number | number[]) => string
}

type SliderValueProps = SliderValueType & {
  value?: number[]
}

export const SliderValue = ({
  value = [],
  outputLabel = (value) => `Current value is ${value}`
}: SliderValueProps) => {
  return (
    <Text className="text-grey-700 mt-4 w-full">
      {outputLabel(value.length === 1 ? value[0] : value)}
    </Text>
  )
}
